import { Component } from '@angular/core';
import { PrismDataSource } from '../../../models/prism-data-source.model';
import { GlobalFilterService } from '../../../services/global-filter.service';
import { ReconApiService } from '../../../services/recon-api.service';

@Component({selector: 'app-home-welcome', templateUrl: 'welcome.component.html'})
export class WelcomeComponent {
    constructor(
        private globalFilterService: GlobalFilterService,
        private reconApiService: ReconApiService,
    ) {}

    get clientName(): string {
        if (this.globalFilterService == null || this.globalFilterService.clientEnvironments == null) {
            return '';
        }
        return this.globalFilterService.clientEnvironments[0].Description;
    }

    get selectedClient(): string {
        if (this.globalFilterService == null || this.globalFilterService.clientEnvironments == null) {
            return '';
        }
        return JSON.stringify(this.globalFilterService.selectedEnvironment, null, 4);
    }

    // TODO: Remove this function and the button in the UI associated with the calling of it.
    public testEnvironmentAvailability() {
        this.reconApiService.getEnvironmentInformation(this.globalFilterService.selectedEnvironment.ClientId3Digit);
    }

}



// WEBPACK FOOTER //
// ./src/app/home/components/welcome/welcome.component.ts